import clsx from 'clsx';
import React from 'react';
import { IconName, SVGIcon } from '../SVGIcon';

export interface SectionSubtitleProps {
  title: string;
  description?: string;
  description2?: string;
  icon?: IconName;
}

function SectionSubtitle({
  title,
  description,
  description2,
  icon,
}: SectionSubtitleProps) {
  return (
    <div className="relative">
      <div className="relative flex items-center">
        {icon && (
          <div
            className={clsx(
              'relative mr-2 inline-flex h-[38px] w-[38px] flex-shrink-0 flex-grow-0 items-center justify-center gap-2.5 rounded-xl bg-blue lg:h-[46px] lg:w-[46px]',
            )}
          >
            <SVGIcon name={icon} fill="white" size="sm" />
          </div>
        )}
        <p className="text-left text-xl font-bold text-text-primary lg:text-[26px]">
          {title}
        </p>
      </div>
      {description && (
        <p className="pt-3 text-left text-sm text-text-secondary">
          {description}
        </p>
      )}
      {description2 && (
        <p className="text-left text-sm text-text-secondary">{description2}</p>
      )}
    </div>
  );
}

export default SectionSubtitle;
export { SectionSubtitle };
